"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
exports.default = (config) => {
    return (0, util_1.createResource)({
        axios: config.axios,
        path: 'network',
    });
};
